import {
	Dialog,
	DialogSurface,
	DialogTitle,
	DialogContent,
	DialogBody,
	DialogActions,
	Button,
} from '@fluentui/react-components';
import { useAutomationRuleActivity } from './activity-provider';
import { parseJsonData } from './parse-json-data';

export default function DetailsDialog() {
	const {openDetails, openDetailsHandler, details} = useAutomationRuleActivity();

	if (!details) return null;

	return (
		<Dialog open={openDetails} onOpenChange={() => openDetailsHandler()} >
			<DialogSurface style={{ width: '90vw', maxWidth: '1000px'}}>
				<DialogBody>
					<DialogTitle>Activity details</DialogTitle>
					<DialogContent>
						{parseJsonData(details)}
					</DialogContent>
					<DialogActions>
						<Button
							appearance="secondary"
							onClick={() => {
								openDetailsHandler();
							}}
						>
              Close
						</Button>
					</DialogActions>
				</DialogBody>
			</DialogSurface>
		</Dialog>
	);
}